import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'employees',
    component: Children,

    children: [
      {
        path: '',
        name: 'employees',
        component: () => import('../pages/EmployeesPage.vue')
      },
      {
        path: 'create',
        name: 'employees.create',
        component: () => import('../pages/EmployeesCreatePage.vue')
      },
      {
        path: ':id',
        name: 'employees.show',
        component: () => import('../pages/EmployeesShowPage.vue'),
        props: route => ({
          id: Number(route.params.id)
        })
      }
    ]
  }
];

export default routes;
